// 📱 iPhone 데이터 (간소화된 구조)
import type { IPhoneSeriesData } from './deviceDataHelpers';

export const IPHONE_DATA: IPhoneSeriesData[] = [
  {
    series: 'iPhone 17',
    models: [
      { en: 'iPhone 17', ko: '아이폰17', storages: ['128GB', '256GB', '512GB'], year: 2025, recommended: true },
      { en: 'iPhone 17 AIR', ko: '아이폰17 AIR', storages: ['256GB', '512GB'], year: 2025, recommended: true },
      { en: 'iPhone 17 Pro', ko: '아이폰17 PRO', storages: ['256GB', '512GB', '1TB'], year: 2025, recommended: true },
      { en: 'iPhone 17 Pro Max', ko: '아이폰17 PRO MAX', storages: ['256GB', '512GB', '1TB'], year: 2025, recommended: true }
    ]
  },
  {
    series: 'iPhone 16',
    models: [
      { en: 'iPhone 16', ko: '아이폰16', storages: ['128GB', '256GB', '512GB'], year: 2024, recommended: true },
      { en: 'iPhone 16 Plus', ko: '아이폰16 Plus', storages: ['128GB', '256GB', '512GB'], year: 2024, recommended: true },
      { en: 'iPhone 16 Pro', ko: '아이폰16 PRO', storages: ['256GB', '512GB', '1TB'], year: 2024, recommended: true },
      { en: 'iPhone 16 Pro Max', ko: '아이폰16 PRO MAX', storages: ['256GB', '512GB', '1TB'], year: 2024, recommended: true },
      { en: 'iPhone 16e', ko: '아이폰16e', storages: ['128GB', '256GB'], year: 2024 }
    ]
  },
  {
    series: 'iPhone 15',
    models: [
      { en: 'iPhone 15', ko: '아이폰15', storages: ['128GB', '256GB', '512GB'], year: 2023, recommended: true },
      { en: 'iPhone 15 Plus', ko: '아이폰15 Plus', storages: ['128GB', '256GB', '512GB'], year: 2023, recommended: true },
      { en: 'iPhone 15 Pro', ko: '아이폰15 PRO', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2023, recommended: true },
      { en: 'iPhone 15 Pro Max', ko: '아이폰15 PRO MAX', storages: ['256GB', '512GB', '1TB'], year: 2023, recommended: true }
    ]
  },
  {
    series: 'iPhone 14',
    models: [
      { en: 'iPhone 14', ko: '아이폰14', storages: ['128GB', '256GB', '512GB'], year: 2022 },
      { en: 'iPhone 14 Plus', ko: '아이폰14 Plus', storages: ['128GB', '256GB', '512GB'], year: 2022 },
      { en: 'iPhone 14 Pro', ko: '아이폰14 PRO', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2022 },
      { en: 'iPhone 14 Pro Max', ko: '아이폰14 PRO MAX', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2022 }
    ]
  },
  {
    series: 'iPhone 13',
    models: [
      { en: 'iPhone 13', ko: '아이폰13', storages: ['128GB', '256GB', '512GB'], year: 2021 },
      { en: 'iPhone 13 Mini', ko: '아이폰13 MINI', storages: ['128GB', '256GB', '512GB'], year: 2021 },
      { en: 'iPhone 13 Pro', ko: '아이폰13 PRO', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2021 },
      { en: 'iPhone 13 Pro Max', ko: '아이폰13 PRO MAX', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2021 }
    ]
  },
  {
    series: 'iPhone 12',
    models: [
      { en: 'iPhone 12', ko: '아이폰12', storages: ['64GB', '128GB', '256GB'], year: 2020 },
      { en: 'iPhone 12 Mini', ko: '아이폰12 MINI', storages: ['64GB', '128GB', '256GB'], year: 2020 },
      { en: 'iPhone 12 Pro', ko: '아이폰12 PRO', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      { en: 'iPhone 12 Pro Max', ko: '아이폰12 PRO MAX', storages: ['128GB', '256GB', '512GB'], year: 2020 }
    ]
  },
  {
    series: 'iPhone 11',
    models: [
      { en: 'iPhone 11', ko: '아이폰11', storages: ['64GB', '128GB', '256GB'], year: 2019 },
      { en: 'iPhone 11 Pro', ko: '아이폰11 PRO', storages: ['64GB', '256GB', '512GB'], year: 2019 },
      { en: 'iPhone 11 Pro Max', ko: '아이폰11 PRO MAX', storages: ['64GB', '256GB', '512GB'], year: 2019 }
    ]
  },
  {
    series: 'iPhone X',
    models: [
      { en: 'iPhone X', ko: '아이폰X', storages: ['64GB', '256GB'], year: 2017 },
      { en: 'iPhone XS', ko: '아이폰 XS', storages: ['64GB', '256GB', '512GB'], year: 2018 },
      { en: 'iPhone XS Max', ko: '아이폰 XS MAX', storages: ['64GB', '256GB', '512GB'], year: 2018 },
      { en: 'iPhone XR', ko: '아이폰 XR', storages: ['64GB', '128GB', '256GB'], year: 2018 }
    ]
  },
  {
    series: 'iPhone 8',
    models: [
      { en: 'iPhone 8', ko: '아이폰8', storages: ['64GB', '256GB'], year: 2017 },
      { en: 'iPhone 8 Plus', ko: '아이폰8 Plus', storages: ['64GB', '256GB'], year: 2017 }
    ]
  },
  {
    series: 'iPhone 7',
    models: [
      { en: 'iPhone 7', ko: '아이폰7', storages: ['32GB', '128GB', '256GB'], year: 2016 },
      { en: 'iPhone 7 Plus', ko: '아이폰7 Plus', storages: ['32GB', '128GB', '256GB'], year: 2016 }
    ]
  },
  {
    series: 'iPhone 6',
    models: [
      { en: 'iPhone 6', ko: '아이폰6', storages: ['16GB', '32GB', '64GB', '128GB'], year: 2014 },
      { en: 'iPhone 6 Plus', ko: '아이폰6 Plus', storages: ['16GB', '32GB', '64GB', '128GB'], year: 2014 },
      { en: 'iPhone 6S', ko: '아이폰6S', storages: ['16GB', '32GB', '64GB', '128GB'], year: 2015 },
      { en: 'iPhone 6S Plus', ko: '아이폰6S Plus', storages: ['16GB', '32GB', '64GB', '128GB'], year: 2015 }
    ]
  },
  {
    series: 'iPhone SE',
    models: [
      { en: 'iPhone SE', ko: '아이폰SE', storages: ['16GB', '32GB', '64GB', '128GB'], year: 2016 },
      { en: 'iPhone SE 2nd', ko: '아이폰SE2', storages: ['64GB', '128GB', '256GB'], year: 2020 },
      { en: 'iPhone SE 3rd', ko: '아이폰SE3', storages: ['64GB', '128GB', '256GB'], year: 2022 }
    ]
  }
];

// 이미지 경로 자동 생성 함수
export const generateIPhoneImagePath = (series: string, model: string): string => {
  const seriesFolder = series.replace(' ', '');
  const fileName = model.toLowerCase()
    .replace(/\s+/g, '')
    .replace('iphone', 'iphone')
    .replace('se', '-se')
    .replace('pro', 'pro')
    .replace('max', '-max')
    .replace('plus', 'plus');
  
  if (series === 'iPhone SE') {
    return `/assets/iPhone/iPhoneSE/${fileName}.jpg`;
  }
  
  return `/assets/iPhone/${seriesFolder}/${fileName}.png`;
};
